import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import './home.scss'
import { useInView } from 'react-intersection-observer'
import HeroSection from 'src/components/HeroSection'
import ServicesWidget from 'src/components/ServicesWidget'
import Industries from 'src/components/IndustriesWidget'
import TechnologiesSection from 'src/components/Technologies'
import NewsletterService from '../../services/NewsletterService'
import ModalFormResponse from 'src/components/modals/ModalFormResponse'
import { createRoot } from "react-dom/client";


const Home = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME
  let params = useParams()
  const service = {
    newsletter: new NewsletterService()
  }

  useEffect(() => {
    document.title = companyName + ' - Home'
    let metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute("content", `Your software projects powered by experts, ${companyName} provides customers with expertise across an extensive array of technologies and platforms.`)
    }

    if (params.unsubscribe) {
      const payload = {
        param: params.unsubscribe
      }
      service.newsletter.retrieveSubscriber(payload).then((resp: any) => {
        console.log('NIDZONI : ', resp)
        if (!resp.error) {
          const modalTitle = <span className='orange'>Please Confirm</span>
          const modalMessage = <>Are you sure you want to unsubscribe?.<br /><br /><button style={{color: 'grey'}}>Yes</button><button style={{color: 'grey'}}>No</button></>
          createRoot(document.getElementById('modal-responses')).render(<ModalFormResponse status={true} message={modalMessage} title={modalTitle} />)
        }
      }).catch(error => {
        console.log('ERR NIDZONI: ', error)
      })
    }
  }, [])

  const [refIndustries, inViewIndustries] = useInView({
    triggerOnce: true,
    root: null,
    rootMargin: '0px',
    threshold: 1,
    fallbackInView: true,
  })

  const [refServices, inViewServices] = useInView({
    triggerOnce: true,
    root: null,
    rootMargin: '0px',
    threshold: 1,
    fallbackInView: true,
  })
  const [refTechnologies, inViewTechnologies] = useInView({
    triggerOnce: true,
    root: null,
    rootMargin: '0px',
    threshold: 1,
    fallbackInView: true,
  })

  return (
    <>
      <HeroSection />

      <section ref={refTechnologies} className="technologies-section home-section thin-gray-bck">
        {inViewTechnologies ?
          <TechnologiesSection /> : null
        }
      </section>

      <section ref={refServices} className='services-widget home-section black-bck'>
        {inViewServices ?
          <ServicesWidget /> : null
        }
      </section>

      <section ref={refIndustries} className='industries-section home-section white-bck'>
        {inViewIndustries ?
          <Industries isHomepage={true} bckColorClass={'white-bck'} />
          : null
        }
      </section>
    </>
  )
}

export default Home
